var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,13.1c0.7-0.1,1.3,0.1,1.8,0.6l1.2,1.2l1.1-1.1l-1.6-1.6c-0.3-0.3-0.3-0.7,0-0.9c0.3-0.3,0.7-0.3,0.9,0 l1.6,1.6l1.1-1.1l-1.2-1.2c-0.5-0.5-0.7-1.1-0.6-1.8c0.2-1.5-0.3-3.1-1.4-4.3c-1.2-1.2-2.8-1.7-4.3-1.4c-0.2,0-0.3,0.3-0.2,0.5 l1.5,1.5c0.7,0.7,0.7,1.9,0,2.6L7.8,8.7c-0.7,0.7-1.9,0.7-2.6,0L3.6,7.2C3.5,7,3.2,7.1,3.1,7.3c-0.2,1.5,0.2,3.2,1.4,4.3 C5.7,12.8,7.3,13.3,8.8,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,15.1l-1.1,1.1L24,23c0.3,0.3,0.3,0.7,0,0.9s-0.7,0.3-0.9,0l-6.7-6.7l-1.1,1.1l6.9,6.9 c0.9,0.9,2.3,0.9,3.2,0c0.9-0.9,0.9-2.3,0-3.2L18.4,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,10.7h3l3-6l-1.5-1.5l-6,3v3l-8.1,8.1l-1.5-1.5l-5.9,5.9c-1.2,1.2-1.2,3.2,0,4.4c1.2,1.2,3.2,1.2,4.4,0 l5.9-5.9l-1.5-1.5L21,10.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPreview);
export default __webpack_public_path__ + "static/media/settings-preview.bd65ec6a8fd4981243965bfdedd7ad3b.svg";
export { ForwardRef as ReactComponent };